import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import { PsHttpService } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type {
    BatchUploadImagesApi,
    BatchUploadImagesRequest,
    BatchUploadImagesResponse,
} from '../batch-upload-images-api';
import type { SignFilesApi, SignFilesRequest, SignFilesResponse } from '../sign-files-api';
import {
    IMAGE_UPLOAD_API_PATHS,
    DEFAULT_IMAGE_FOLDER_PATH,
    DEFAULT_IMAGE_FILE_PREFIX,
} from '../../constants';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';

@injectable()
export class ImageUploadApiImpl
    extends PsHttpService
    implements BatchUploadImagesApi, SignFilesApi
{
    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async batchUploadImages(
        request: BatchUploadImagesRequest,
    ): Promise<BatchUploadImagesResponse> {
        const formData = new FormData();

        // 添加文件列表
        for (const file of request.files) {
            formData.append('files', file);
        }

        // 添加可选参数
        formData.append('folder_path', request.folder_path ?? DEFAULT_IMAGE_FOLDER_PATH);
        formData.append('file_prefix', request.file_prefix ?? DEFAULT_IMAGE_FILE_PREFIX);
        formData.append('generate_unique_name', String(request.generate_unique_name ?? true));

        const result = await this.post<PatSnapSuccessResponseData<BatchUploadImagesResponse>>({
            url: IMAGE_UPLOAD_API_PATHS.BATCH_UPLOAD,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return result.data;
    }

    async signFiles(request: SignFilesRequest): Promise<SignFilesResponse> {
        const result = await this.post<PatSnapSuccessResponseData<SignFilesResponse>>({
            url: IMAGE_UPLOAD_API_PATHS.SIGN_FILES,
            data: request,
        });

        return result.data;
    }
}
